export class EmailAttachment {
    constructor(emailAttachmentState) {
        this.emailAttachmentState = emailAttachmentState;
    }
    get id() { return this.emailAttachmentState.id; }
    get file_id() { return this.emailAttachmentState.file_id; }
    get email_log_id() { return this.emailAttachmentState.email_log_id; }
    get date_created() { return this.emailAttachmentState.date_created; }
    set id(id) { this.emailAttachmentState.id = id; }
    set file_id(file_id) { this.emailAttachmentState.file_id = file_id; }
    set email_log_id(email_log_id) { this.emailAttachmentState.email_log_id = email_log_id; }
    set date_created(date_created) { this.emailAttachmentState.date_created = date_created; }
    getState() { return this.emailAttachmentState; }
}
